require("./scss/main.scss");

import { initApp } from "./js/core/app.js";

document.addEventListener("DOMContentLoaded", initApp);
